import { getRequestedContent } from '@annunciate/core/dist/utils/player';
import { updateCachedProgress } from './updateCachedProgress';
export const onProgressUpdate = async (client, position) => {
    if (position === undefined)
        return;
    const { content, isPlaying, type } = getRequestedContent();
    if (!content || !isPlaying || !type)
        return;
    updateCachedProgress(client, { contentId: content.id, position, sync: true });
};
//# sourceMappingURL=onProgressUpdate.js.map